import { GiftLayout } from './GiftLayout'

export default GiftLayout
// eslint-disable-next-line import/export
export * from './GiftLayout'
